import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { ImageData } from '../../hooks/usePropertyInformationQuery';
import { Typography } from '@mui/material';

interface Props {
  isOpen: boolean;
  close: () => void;
  images: ImageData[] | [];
}

export const CheckoutSummaryPhotoGallery = ({ isOpen, close, images }: Props) => {


  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle={"Photo Gallery"}
      maxWidth="sm"
      useIsXs={false}
    >
      <Grid container spacing={2}>
        {images?.map((imagData, index) => {
          return (
            <Grid item xs={12} key={index} mb={2}>
              <img src={imagData?.THUMB} style={{ width: '100%', borderRadius: '5px' }} />
              <Typography variant="body2">{imagData?.CAPTION}</Typography>
            </Grid>
          )
        })}
      </Grid>

    </ConfirmationDialog >
  );
};
